import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Select, Spin } from "antd";
import { createAttachedSignature } from "crypto-pro";
import { nanoid } from "nanoid";
import { ReactElement, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  API_AUTH_CSP,
  TypeInitialState,
} from "../../../store/slice/authSliceLogin/authSliceLogin";
import { useThunkActionLoadingState } from "../../../utils/Hooks/useThunkActionLoadingState";
import { IAgentLoginResponse } from "../types/types";

import classes from "./ClientLoginForm.module.css";

export function ClientLoginForm(): ReactElement {
  const CSP = useSelector(
    (state: { authSlice: TypeInitialState }) => state.authSlice.CSP,
  );
  const [disableBtn, setDisableBtn] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isFetching, sendQuery } = useThunkActionLoadingState();

  async function onFinish(CSP_VALUE: { thumbprint: string }) {
    const TextThumbprint = nanoid();
    const { thumbprint } = CSP_VALUE;
    createAttachedSignature(thumbprint, TextThumbprint).then(
      async (SIGNATURE) => {
        try {
          const response = await sendQuery<IAgentLoginResponse>(
            API_AUTH_CSP({ thumbprint: SIGNATURE, type: "login" }),
          );

          if (response?.data?.success) {
            navigate("/");
          }
        } catch (error) {
          console.error(error);
        }
      },
    );
  }

  const cspOptions = CSP?.CSP_FILTER?.map((item, index: number) => {
    if (item.inn_ul) {
      return {
        key: index,
        value: `${item.thumbprint}`,
        label: `${item.owner} ИНН-${item.inn_ul}`,
      };
    }
    return {
      key: index,
      value: `${item.thumbprint}`,
      label: `${item.owner} ИНН-${item.inn}`,
    };
  });

  const submitBtnChild = isFetching ? (
    <Spin
      indicator={<LoadingOutlined className="loader-white" spin />}
      size="small"
    />
  ) : (
    "Войти"
  );

  return (
    <>
      <Form
        onFinish={onFinish}
        form={form}
        className={classes.formContainer}
        name="CSP_LOGIN"
        layout="vertical"
        onFieldsChange={(_undefined, allFields) => {
          const allFieldsFilled = allFields?.every(
            (field) =>
              field.value !== undefined &&
              field.value !== "" &&
              field.value !== false,
          );
          setDisableBtn(!allFieldsFilled);
        }}
      >
        <Form.Item
          className={classes.mainFormContent}
          name={"thumbprint"}
          label="Выберите ЭЦП:"
          layout="vertical"
        >
          <Select size="large" options={cspOptions} placeholder="ЭЦП..." />
        </Form.Item>

        <Button
          disabled={disableBtn || isFetching}
          size="large"
          className={`${classes.submitBtn} ${classes.cspSignIn}`}
          variant="solid"
          color={"primary"}
          htmlType="submit"
        >
          {submitBtnChild}
        </Button>
      </Form>
    </>
  );
}
